// 演示用「上班/下班」状态：班次时段与上下班动作都在顶栏用户名下拉里。
// 目前是假界面，只改本地状态；真实实现接坐席/值班状态与考勤接口即可。

import { create } from 'zustand';

interface ShiftState {
  onDuty: boolean;
  setOnDuty: (v: boolean) => void;
}

export const useShiftStore = create<ShiftState>((set) => ({
  onDuty: true,
  setOnDuty: (v) => set({ onDuty: v }),
}));
